import { quizErrorMessages } from '@repo/lib/messages/quizErrorMessages';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useErrorMessage } from '#error-message/useErrorMessage';

import type { DeleteQuizData, QuizAssignedDataWithAttempts } from './quizService';

import { QuizKey } from './keys';
import { QuizService } from './quizService';

export function useDeleteQuiz() {
  const queryClient = useQueryClient();
  const deleteQuizMutation = useMutation({
    mutationFn: (data: DeleteQuizData) => QuizService.deleteQuiz(data).then((response) => response.data),
    onMutate: async (data: DeleteQuizData) => {
      await queryClient.cancelQueries({ queryKey: [QuizKey.ASSIGNED_QUIZZES] });
      const previousQuizzes = queryClient.getQueryData([QuizKey.ASSIGNED_QUIZZES]);
      queryClient.setQueryData([QuizKey.ASSIGNED_QUIZZES], (prev?: QuizAssignedDataWithAttempts[]) => {
        if (!prev) {
          return [];
        }
        return prev.filter((quiz) => quiz.id !== data.quizId);
      });
      return { previousQuizzes };
    },
    onError: (_error, _data, context) => {
      if (context?.previousQuizzes) {
        queryClient.setQueryData([QuizKey.ASSIGNED_QUIZZES], context.previousQuizzes);
      }
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [QuizKey.ASSIGNED_QUIZZES],
      });
    },
  });

  const errorMessage = useErrorMessage(deleteQuizMutation.error, quizErrorMessages);

  return { ...deleteQuizMutation, errorMessage };
}
